export const settings = [
  {
    label: "Background",
    selector: "background",
    type: "background-image",
    value: "url(//pages.convertkit.com/assets/charlotte/bg.jpg)"
  },
  {
    label: "Form background",
    selector: "form",
    type: "background-color",
    value: "#fff"
  },
  {
    label: "Border radius",
    selector: "form",
    type: "border-radius",
    value: 6
  },

  {
    group: "header",
    selector: "header",
    type: "color",
    value: "#535353"
  },
  {
    group: "header",
    selector: "header",
    type: "font-size",
    value: 28
  },
  {
    group: "header",
    selector: "header",
    type: "font-weight",
    value: 700
  },
  {
    group: "field",
    selector: "field",
    type: "color",
    value: "#8b8b8b"
  },
  {
    group: "field",
    selector: "field",
    type: "border-color",
    value: "#dde0e4"
  },
  {
    group: "field",
    selector: "field",
    type: "font-weight",
    value: 400
  },
  {
    group: "button",
    selector: "button",
    type: "color",
    value: "#ffffff"
  },
  {
    group: "button",
    selector: "button",
    type: "background-color",
    value: "#f6a6ab"
  },
  {
    group: "button",
    selector: "button",
    type: "border-radius",
    value: 3
  },
  {
    group: "button",
    selector: "button",
    type: "font-weight",
    value: 700
  },
  {
    group: "disclaimer",
    selector: "disclaimer",
    type: "color",
    value: "#8b8b8b"
  },
  {
    group: "disclaimer",
    selector: "disclaimer",
    type: "font-size",
    value: 13
  }
]
